import React from "react";
import "../assets/styles/kvkk.scss"
import { kvkkContent, LegalContent, LegalBlock } from "../data/kvkkContent";
import AboutHero from "../components/common/AboutHero";
import Recete3 from "../assets/images/recete3.jpg";

type Props = {
  content?: LegalContent; // dışarıdan da gönderilebilir
};

const BlockRenderer: React.FC<{ block: LegalBlock }> = ({ block }) => {
  switch (block.type) {
    case "p":
      return <p className="lg-p">{block.text}</p>;
    case "subtitle":
      return <h4 className="lg-subtitle">{block.text}</h4>;
    case "note":
      return <div className="lg-note">{block.text}</div>;
    case "ul":
      return (
        <ul className="lg-list">
          {block.items.map((it, i) => (
            <li key={i}>{it}</li>
          ))}
        </ul>
      );
    case "ol":
      return (
        <ol className="lg-list numbered">
          {block.items.map((it, i) => (
            <li key={i}>{it}</li>
          ))}
        </ol>
      );
    default:
      return null;
  }
};

const KvkkPage: React.FC<Props> = ({ content }) => {
  const data = content ?? kvkkContent;

  return (
    <>
      <AboutHero
        image={Recete3}
        kicker="KVKK"
        title="Kişisel Verilerin İşlenmesine İlişkin Aydınlatma Metni"
        description=""
        overlayColor="#2cadd2"
        overlayOpacity={0.72}
        accentColor="#e30613"
        textColor="#2b2b2b"
        focus="center center"
        align="center"
        desktopHeight={460}
        tabletHeight={380}
        mobileHeight={320}
      />
      <section className="legal-page">
        {/* HERO */}
        <header className="lg-hero">
          <div className="lg-hero__inner">
            <div className="lg-hero__content">
              <h1 className="lg-main-title">{data.hero?.kicker || "ÖZEL MEGAPARK HASTANESİ"}</h1>
              <div className="lg-intro">
                <h2 className="lg-subtitle-main">{data.pageTitle}</h2>
                <p className="lg-description">
                  {data.hospitalName} (kısaca "Hastane")'nin bağlı olduğu tüzel kişilik MARSAM Özel Sağlık Hiz. İnş.
                  Turizm San. ve Tic. AŞ tarafından 6698 sayılı Kişisel Verilerin Korunması Kanunu (kısaca "Kanun") ve ilgili mevzuat
                  kapsamında Veri Sorumlusu sıfatıyla, kişisel verileriniz, aşağıda açıklanan çerçevede ve 3359 sayılı Sağlık
                  Hizmetleri Temel Kanunu, 663 sayılı Sağlık Bakanlığı ve Bağlı Kuruluşlarının Teşkilat ve Görevleri Hakkında Kanun
                  Hükmünde Kararname, Özel Hastaneler Yönetmeliği ve Sağlık Bakanlığı düzenlemeleri ve sair mevzuata uygun olarak işlenebilecektir.
                </p>
              </div>
              <p className="lg-description">
                Hastalarımızın bizimle paylaştığı her türlü kişisel verinin veri güvenliğini, hasta mahremiyetine özen göstererek ve
                kişisel verilerine uygun düşen her türlü teknik ve idari tedbiri alarak muhafaza etmekteyiz.
              </p>
            </div>
            {data.hero?.rightLogoUrl && (
              <div className="lg-hero__logo">
                <img src={data.hero.rightLogoUrl} alt="Logo" />
              </div>
            )}
          </div>
        </header>

        <div className="lg-container">
          {/* CONTENT */}
          <main className="lg-content">
            {data.sections.slice(1).map((s) => (
              <article id={s.id} key={s.id} className="lg-section">
                <h3 className="lg-section-title">{s.title}</h3>
                {s.blocks.map((b, i) => (
                  <BlockRenderer key={i} block={b} />
                ))}
              </article>
            ))}
          </main>
        </div>
      </section>
    </>
  );
};

export default KvkkPage;
